import { __require as T } from "./main30.js";
import { __require as b } from "./main31.js";
import { __require as f } from "./main32.js";
var r, n;
function q() {
  if (n) return r;
  n = 1;
  var t = T(), a = b(), o = f(), u = "[object Null]", g = "[object Undefined]", i = t ? t.toStringTag : void 0;
  function _(e) {
    return e == null ? e === void 0 ? g : u : i && i in Object(e) ? a(e) : o(e);
  }
  return r = _, r;
}
export {
  q as __require
};
